// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

// constant
const icons = {
    ManageAccountsIcon
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const dashboard = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'Dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard',
            icon: icons.ManageAccountsIcon,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
